package com.downdogapp.client.controllers

import com.downdogapp.client.Strings
import com.downdogapp.client.Stripe
import com.downdogapp.client.api.*
import com.downdogapp.client.resources.Images
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Network

class PurchaseGiftViewController(
  val products: List<GiftProduct>,
  val giftTitle: String,
  val giftSubtitle: String,
) : com.downdogapp.client.ViewController() {

  private var paymentPending = false

  override val view = com.downdogapp.client.views.PurchaseGiftView(this)

  fun purchaseGift(productId: String) {
    if (!paymentPending) {
      showSpinner()
      Network.post(PurchaseGiftRequest(productId = productId)) { json ->
        hideSpinner()
        val response = json?.let { StripeSessionResponse.fromJson(it) }

        if (response != null) {
          if (response.id != null) {
            Stripe.promptPurchase(
              sessionId = response.id,
              onError = this::onPurchaseFailed
            )
          } else {
            onPurchaseFailed(response.errorMessage)
          }
        } else {
          App.alertNoInternet()
        }
      }
    }
  }

  fun onPurchaseFailed(errorMessage: String?) {
    if (errorMessage == null) {
      App.alertNoInternet()
    } else {
      App.alert(title = Strings.ERROR_OCCURRED_MESSAGE, message = errorMessage)
    }
    paymentPending = false
    view.hideSpinner()
  }

  fun showSpinner() = view.showSpinner()
  fun hideSpinner() = view.hideSpinner()

  fun getImage(appType: AppType) =
    when (appType) {
      AppType.ORIGINAL -> Images.PURCHASE_TILE_ACTIVE_ORIGINAL
      AppType.INTRO, AppType.SEVEN, AppType.PRENATAL -> null
      AppType.HIIT -> Images.PURCHASE_TILE_ACTIVE_HIIT
      AppType.BARRE -> Images.PURCHASE_TILE_ACTIVE_BARRE
      AppType.MEDITATION -> Images.PURCHASE_TILE_ACTIVE_MEDITATION
      AppType.RUNNING -> Images.PURCHASE_TILE_ACTIVE_RUNNING
      AppType.BREATHING -> Images.PURCHASE_TILE_ACTIVE_BREATHING
      AppType.PILATES -> Images.PURCHASE_TILE_ACTIVE_PILATES
    }
}
